import { render, staticRenderFns } from "./SoftwareDashboard.vue?vue&type=template&id=2da268f6&scoped=true&"
import script from "./SoftwareDashboard.vue?vue&type=script&lang=js&"
export * from "./SoftwareDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da268f6",
  null
  
)

export default component.exports